//export const API_URL = "https://chatbot-ai-api.herokuapp.com"
export const API_URL = "https://chatbot-test-ai.herokuapp.com"
//export const API_URL = "http://127.0.0.1:8000"
